import axios from 'axios';

const url = '/api/v1/external/users';

class UserService {

    static async createUser(user, token) {
        
        return await axios.post(url, {
            user: user
        }, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static deleteUser(id, token) {
        
        return new Promise(async (resolve, reject) => {

            if((id === null) || (typeof id == 'undefined')) {
          
                reject("Id must be supplied.")
                
      
            } else if((token === null) || (typeof token == 'undefined')) {
          
                reject("Token must be supplied.")
                
      
            } else {

            

                let response = await axios.delete(url + '/' + id, {
                    headers: {Authorization: `Bearer ${token}`}
                })
                
                //////console.log('UserService.deleteUser has result = ' + JSON.stringify(response))

                resolve(response)

            }

        })
        
    }

    static deleteUserPrefs(id, token) {
        
        return new Promise(async (resolve, reject) => {

            if((id === null) || (typeof id == 'undefined')) {
          
                reject("Id must be supplied.")
                
      
            } else if((token === null) || (typeof token == 'undefined')) {
          
                reject("Token must be supplied.")
                
      
            } else {

            

                let response = await axios.delete(url + '/prefs/' + id, {
                    headers: {Authorization: `Bearer ${token}`}
                })
                
                //////console.log('UserService.deleteUserPrefs has result = ' + JSON.stringify(response))

                resolve(response)

            }

        })
        
    }
    
    static createUserPrefs(prefs, token) {
        
        return new Promise(async (resolve, reject) => {

            let result = await axios.post(url + "/prefs", {
                prefs: prefs
            }, {
                headers: {Authorization: `Bearer ${token}`}
            })
            
            ////////console.log(JSON.stringify(result))

            resolve(result.data.result);

        })
    }

    static getUser(emailAddress, token) {
        
        return new Promise(async (resolve, reject) => {

            ////////console.log("UserService.getUser with " + emailAddress + ' and ' + token)
        
            let resp = await axios.get(url + "/" + emailAddress, {
                headers: {Authorization: `Bearer ${token}`}
            })

            ////////console.log("Resp = " + JSON.stringify(resp));

            resolve(resp.data.user)

        })

    }

    static getUserPrefs(ownerId, token) {
        
        return new Promise(async (resolve, reject) => {

            await axios.get(url + "/prefs/" + ownerId, {
                headers: {Authorization: `Bearer ${token}`}
            }).then((response) => {
                // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed console.log
                resolve(response.data.result.data);
    
            }).catch((error) => {
                // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed console.log
                reject(error)

            })
            
            

            

        })
    }

    static updateUser(user, token) {
        
        return new Promise(async (resolve, reject) => {

            let result = await axios.put(url, {
                user: user
            }, {
                headers: {Authorization: `Bearer ${token}`}
            })
            
            ////////console.log(JSON.stringify(result))

            resolve(result.data.result);

        })
    }

    static updateUserPrefs(prefs, token) {
        
        return new Promise(async (resolve, reject) => {

            let result = await axios.put(url + "/prefs", {
                prefs: prefs
            }, {
                headers: {Authorization: `Bearer ${token}`}
            })
            
            ////////console.log(JSON.stringify(result))

            resolve(result.data.result);

        })
    }

    // 20260405 -- Copilot (Claude Sonnet 4.6) -- Record explicit login event for admin dashboard instrumentation
    // WHY: lastLoggedIn must only be stamped on real logins, not silent token refreshes
    static recordLogin(token) {
        return axios.patch('/api/v3/user/last-logged-in', {}, {
            headers: { Authorization: `Bearer ${token}` }
        })
    }

    // 20260413 -- Copilot (Claude Sonnet 4.6) -- Record daily app-open event for activity streak and rolling active-days tracking
    // WHY: Powers in-app review eligibility and future dashboard/email marketing segmentation
    static recordActivity(token) {
        return axios.patch('/api/v3/user/activity', {}, {
            headers: { Authorization: `Bearer ${token}` }
        })
    }

    // 20260125 -- Copilot (Claude Sonnet 4.5) -- Get user task statistics
    // WHY: Provide today/7days/30days counts for header
    static getUserStats(token) {
        return new Promise(async (resolve, reject) => {
            try {
                // Get start of today in user's local timezone
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                const startOfToday = today.getTime()
                
                const result = await axios.get('/api/v3/user/stats', {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { start: startOfToday }
                })
                resolve(result.data)
            } catch (error) {
                reject(error)
            }
        })
    }

}

export default UserService; 